import { Link } from "react-router-dom";
import { Button, Group, Stack, Title } from "@mantine/core";
import LegacyImportedCasePanel from "./LegacyImportedCasePanel";

interface Props {
  caseId: string;
  caseNumber: string;
}

export default function LegacyPathologistCaseView({
  caseId,
  caseNumber,
}: Props) {
  return (
    <Stack gap="lg" p="lg">
      <Group justify="space-between">
        <Title order={1}>{caseNumber}</Title>
        <Group>
          <Button component={Link} to="/pathologist-review" variant="default">
            Back to review queue
          </Button>
          <Button component={Link} to={`/cases/${caseId}`}>
            Open case details
          </Button>
        </Group>
      </Group>
      <LegacyImportedCasePanel caseId={caseId} />
    </Stack>
  );
}
